import { Box } from '@deckee/deck-hand';
import React, { FC, KeyboardEvent } from 'react';
import styled from 'styled-components';

/**
 * Inline so a multi-word station name wraps between its words rather than
 * jumping to the next line as one unbreakable unit, which is what a `button`
 * does: browsers lay buttons out as atomic inline boxes even with
 * `display: inline`.
 */
const InlineLink = styled(Box).attrs({
  as: 'span',
  role: 'button',
  tabIndex: 0,
})`
  cursor: pointer;
`;

export interface StationLinkProps {
  /** Station name. Surrounding whitespace is dropped so punctuation that
   * follows the link cannot wrap onto a line of its own. */
  name: string;
  onClick: () => void;
  color?: string;
  fontWeight?: string;
}

const StationLink: FC<StationLinkProps> = ({
  name,
  onClick,
  color,
  fontWeight,
}) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <InlineLink
      color={color}
      fontWeight={fontWeight}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      {name.trim().replace(/\s+/g, ' ')}
    </InlineLink>
  );
};

StationLink.defaultProps = {
  color: undefined,
  fontWeight: undefined,
};

export default StationLink;
